import { Dialog } from "primereact/dialog"
import { useCallback, useEffect, useState } from "react"
import Fuse from 'fuse.js';
import { useDispatch } from "react-redux";
import _ from "lodash";
import { ThreeDots } from "react-loader-spinner";

import { AutoCompleteField, Button, DropDownField, InputSwitchField, TextInputField } from "../../../helpers"

import { raiseToast } from "../../../services/redux/reducers/toast/toast";
import { getMaterialMasterAndTempMaterialIdsById, inserVMIMaterialMaster } from "../../../services/api/materialMaster";

import { vmiContractItemInitialState, vmiContractItemValidation } from "../../../validation/vmiValidation";
import { validateInputs } from "../../../utils";


const AddMaterial = (props) => {

    const { setVisibleAddMaterial, companyWarehouses, companies, setIsLoading, userDetails, materialBrands } = props

    const [vmiContractItem, setVMIContractItem] = useState(vmiContractItemInitialState)
    const [companySuggestions, setCompanySuggestions] = useState([])
    const [materialDetails, setMaterialDetails] = useState(null)
    const [isTargetStockQty, setIsOrderQty] = useState(false)

    const [formErrors, setFormErrors] = useState([])

    const [isProductDetailsLoading, setIsProductDetailsLoading] = useState(false)

    const dispatch = useDispatch()

    const companyFuzzSearch = useCallback(new Fuse(companies, {
        keys: ['companyName'],
        includeScore: true,
        threshold: 0.5,
        ignoreLocation: true,
        shouldSort: true,
        getFn: (obj) => {
            return obj.companyName.replace(/\s+/g, '')
        },
    }), [companies])

    useEffect(() => {
        setVMIContractItem({
            ...vmiContractItemInitialState,
            companyId: vmiContractItem.companyId,
            warehouseId: vmiContractItem.warehouseId,
            companyERPCode: vmiContractItem.companyERPCode,
            permMaterialId: vmiContractItem.permMaterialId
        })
        setMaterialDetails(null)
        setIsOrderQty(false)
        setFormErrors([])
    }, [vmiContractItem.permMaterialId])

    const companySearchMethod = (event) => {
        if (event.query === "") {
            setCompanySuggestions([...companies])
        }
        else {
            const searchResults = companyFuzzSearch.search(event.query)
            const relatedCompanies = searchResults.map(eachProduct => eachProduct.item)
            setCompanySuggestions(relatedCompanies)
        }
    }

    const handleCompanyChange = (event) => {
        let companyObj = event.target.value
        if (typeof (event.target.value) === "object" && event.target.value !== null){
            companyObj = event.target.value.companyId
        }

        const updatedVMIMaterialItem = {
            ...vmiContractItemInitialState,
            companyId: companyObj
        }

        setVMIContractItem({ ...updatedVMIMaterialItem })
    }

    const handleMaterialDetailsSearch = async () => {
        if (!vmiContractItem.permMaterialId) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Please enter material Id!' }))
        }

        if (vmiContractItem.permMaterialId.length <= 5) {
            return dispatch(raiseToast({ severity: 'error', detail: 'Invalid Material Id' }))
        }

        if(vmiContractItem.permMaterialId.toString()[0] === '8'){
            return dispatch(raiseToast({ severity: 'error', detail: 'Temp Material Id(s) are not allowed VMI' }))
        }

        setIsProductDetailsLoading(true)
        const materialRes = await getMaterialMasterAndTempMaterialIdsById({ materialId: parseFloat(vmiContractItem.permMaterialId) })
        if (materialRes.failure) {
            setIsProductDetailsLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Material Master', detail: materialRes.data.error, life: 3000 }))
        }

        if(!materialRes.data){
            setIsProductDetailsLoading(false)
            return dispatch(raiseToast({ severity: 'error', detail: 'Material not found!', life: 3000 }))
        }

        setMaterialDetails(materialRes.data)
        setFormErrors([])
        setIsProductDetailsLoading(false)
    }

    const handleVMIContractItems = (event) => {
        if (event.target.name === 'safetyStock') {
            if (!vmiContractItem.orderingThresholdQty) {
                return dispatch(raiseToast({ severity: 'error', detail: 'Please enter ordering threshold qty before entering minimum quantity!' }))
            }

            if (parseFloat(event.target.value) > parseFloat(vmiContractItem.orderingThresholdQty)) {
                return dispatch(raiseToast({ severity: 'error', detail: 'Safety Stock should be less than ordering threshold qty!' }))
            }
        }

        if (event.target.name === 'targetStockQty') {
            if (!vmiContractItem.orderingThresholdQty) {
                return dispatch(raiseToast({ severity: 'error', detail: 'Please enter ordering threshold qty before entering Target Stock quantity!' }))
            }
        }

        const updatedVMIMaterialItem = {
            ...vmiContractItem,
            [event.target.name]: event.target.value
        }

        if (event.target.name === 'orderingThresholdQty') {
            updatedVMIMaterialItem.safetyStock = null
        }

        setVMIContractItem({ ...updatedVMIMaterialItem })
    }

    const handleQtyInputSwitch = (event) => {
        setIsOrderQty(event.value)

        const updatedVMIMaterialItem = { ...vmiContractItem }
        setVMIContractItem({ ...updatedVMIMaterialItem })
        if (event.value) {
            setVMIContractItem({ ...vmiContractItem, orderQty: null })
        }
        else {
            setVMIContractItem({ ...vmiContractItem, targetStockQty: null })
        }
    }

    const handleTargetStockQtyOnBlur = (event) => {
        if(event.target.name === "targetStockQty"){
            if (parseFloat(event.target.value) < parseFloat(vmiContractItem.orderingThresholdQty)) {
                return dispatch(raiseToast({ severity: 'error', detail: 'Target stock quantuty should be more than ordering threshold qty!' }))
            }
        }
    }

    const handleVMIMaterialSubmit = async () => {
        const validationRes = await validateInputs(vmiContractItemValidation, vmiContractItem)
        if (validationRes) {
            if (validationRes.error) {
                setFormErrors(validationRes.error)
            }
            else {

                if(isTargetStockQty){
                    if(!parseFloat(vmiContractItem.targetStockQty)){
                        return dispatch(raiseToast({ severity: 'error', detail: 'Please enter Target Stock Qty!' }))
                    }

                    if (parseFloat(vmiContractItem.targetStockQty) < parseFloat(vmiContractItem.orderingThresholdQty)) {
                        return dispatch(raiseToast({ severity: 'error', detail: 'Target stock quantuty should be more than ordering threshold qty!' }))
                    }
                }
                else if (!isTargetStockQty){
                    if(!parseFloat(vmiContractItem.orderQty)){
                        return dispatch(raiseToast({ severity: 'error', detail: 'Please enter Order Qty!' }))
                    }
                }

                const updatedVMIContractItem = {...vmiContractItem, companyERPCode: vmiContractItem.companyERPCode ? vmiContractItem.companyERPCode : null}
                if(isTargetStockQty){
                    updatedVMIContractItem.VMIQtyTypeId = 2
                    updatedVMIContractItem.VMIQty = updatedVMIContractItem.targetStockQty
                }
                else{
                    updatedVMIContractItem.VMIQtyTypeId = 1
                    updatedVMIContractItem.VMIQty = updatedVMIContractItem.orderQty
                }

                if (window.confirm("Are you sure you want to continue!?")) {
                    setIsLoading(true)
                    const materialMasterRes = await inserVMIMaterialMaster({
                        vmiContractItems: [updatedVMIContractItem]
                    })

                    if (materialMasterRes.failure) {
                        setIsLoading(false)
                        return dispatch(raiseToast({ severity: 'error', summary: 'Material Master', detail: materialMasterRes.data.error }))
                    }
                    else {
                        setIsLoading(false)
                        dispatch(raiseToast({ severity: 'success', detail: 'Material successfully added!' }))
                        handleOnHideAddMaterial()
                    }
                }
            }
        }
    }

    const handleOnHideAddMaterial = () => {
        setVMIContractItem(vmiContractItemInitialState)
        setMaterialDetails(null)
        setVisibleAddMaterial(false)
    }

    let companyName = vmiContractItem.companyId
    if (typeof (vmiContractItem.companyId) === "number") {
        companyName = companies.find(eachCompany => eachCompany.companyId === vmiContractItem.companyId)
    }

    let materialSpecs = ''
    if (materialDetails) {
        const relatedBrand = materialBrands.find(eachbrand => eachbrand.brandId === materialDetails.brandId)
        materialSpecs = `${relatedBrand.brandName}-${materialDetails.productName} | ${materialDetails.productSpecification}`
    }

    return (
        <Dialog header="ADD VMI MATERIAL" visible={props.visible} style={{ minHeight: "50%", width: '60vw' }} onHide={handleOnHideAddMaterial}>
            <div className="flex flex-row">
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <AutoCompleteField dropdown name="company" labelText="Company" value={companyName} field="companyName" dropdownButton ClassName="styled-autocomplete-dropdown-button" searchMethod={companySearchMethod} suggestions={companySuggestions} onChange={handleCompanyChange} errorMessage={formErrors.companyId} forceSelection required />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <DropDownField name="warehouseId" labelText="Warehouse" options={companyWarehouses} value={vmiContractItem.warehouseId} optionLabel="warehouseName" optionValue="warehouseId" onChange={handleVMIContractItems} errorMessage={formErrors.warehouseId} required />
                </div>
                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                    <TextInputField name="companyERPCode" labelText="Company ERP Code" value={vmiContractItem.companyERPCode} onChange={handleVMIContractItems} errorMessage={formErrors.companyERPCode} />
                </div>
                <div className="flex flex-row lg:col-4 p-0">
                    <div className="flex flex-column col-12 mb-2 lg:col-7 lg:mb-0 pr-0 sellerpo-input">
                        <TextInputField name="permMaterialId" labelText="Perm Material Id" value={vmiContractItem.permMaterialId} keyfilter={"pnum"} onChange={handleVMIContractItems} required />
                    </div>
                    <div className="flex flex-column col-2 w-2rem align-items-center mt-3 px-0 sellerpo-btn">
                        <Button icon="pi pi-search" className="w-2rem" style={{ height: "35px" }} onClick={handleMaterialDetailsSearch} />
                    </div>
                </div>
            </div>
            <div className='hr-line'></div>
            {
                isProductDetailsLoading ? (
                    <div className="flex flex-column justify-content-between align-items-center">
                        <div className="flex justify-content-center align-items-center h-full">
                            <ThreeDots height="50" width="50" radius="5" color="#00baac" ariaLabel="three-dots-loading" visible={true} />
                        </div>
                    </div>
                ) :
                    materialDetails &&
                    <>
                        <div className="flex">
                            <div className="flex flex-column col-12 lg:col-6 lg:mb-0">
                                <TextInputField name="Material" value={materialSpecs} labelText="Material Specs" disabled tooltip={materialSpecs} tooltipOptions={{ position: 'top', showOnDisabled: true, showDelay: 500, hideDelay: 150 }} />
                            </div>
                        </div>
                        <div className="flex flex-wrap">
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <TextInputField name="orderingThresholdQty" value={vmiContractItem.orderingThresholdQty} errorMessage={formErrors.orderingThresholdQty} keyfilter={"pnum"} onChange={handleVMIContractItems} labelText="Ordering Threshold Qty" required />
                            </div>
                            <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                <TextInputField name="safetyStock" value={vmiContractItem.safetyStock} errorMessage={formErrors.safetyStock} labelText="Safety Stock" keyfilter={"pnum"} onChange={handleVMIContractItems} required />
                            </div>
                            <div className="flex flex-column col-12 lg:col-3 lg:mb-0 pr-0">
                                <label className='adjustment-type-label text-align-center'>Qty Type</label>
                                <div className='flex flex-row  align-items-center mt-2'>
                                    <span className='mr-1'>Order Qty</span>
                                    <span className='mt-1'><InputSwitchField className="" onChange={handleQtyInputSwitch} checked={isTargetStockQty} /></span>
                                    <span className='ml-1'>Target Stock Qty</span>
                                </div>
                            </div>
                            {isTargetStockQty ?
                                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                    <TextInputField name="targetStockQty" value={vmiContractItem.targetStockQty} errorMessage={formErrors.targetStockQty} keyfilter={"pnum"} onChange={handleVMIContractItems} onBlur={handleTargetStockQtyOnBlur} labelText="Target Stock Qty" required />
                                </div>
                                :
                                <div className="flex flex-column col-12 mb-2 lg:col-3 lg:mb-0">
                                    <TextInputField name="orderQty" value={vmiContractItem.orderQty} errorMessage={formErrors.orderQty} keyfilter={"pnum"} onChange={handleVMIContractItems} labelText="Order Qty" required />
                                </div>
                            }
                        </div>
                        <div className='flex justify-content-end mt-2'>
                            <Button label="Add Material" onClick={handleVMIMaterialSubmit} />
                        </div>
                    </>
            }
        </Dialog>
    )
}

export default AddMaterial